import { render, staticRenderFns } from "./ContentReportManagement.vue?vue&type=template&id=f94e68b4&scoped=true"
import script from "./ContentReportManagement.vue?vue&type=script&lang=js"
export * from "./ContentReportManagement.vue?vue&type=script&lang=js"
import style0 from "./ContentReportManagement.vue?vue&type=style&index=0&id=f94e68b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94e68b4",
  null
  
)

export default component.exports